// Which cuts a dragged transition tile may land on (issue 240, live's `availableDrop`): while a
// tile is dragged, every cut shows its mark, a cut it may not land on in red, and the drop goes to
// the nearest cut it may land on. Live's rule, in its own terms: the transition (a set one's length,
// else a new one's) needs half its length of each clip beside the cut, and that half must not
// meet a transition already on the clip's other end.
import { TRANSITION_MS, clipMs, type Junction, type Timeline } from "./timeline";

/** Whether a dragged transition may land on `cut` (live's `availableDrop`). */
export function takesTransition(timeline: Timeline, cut: Junction): boolean {
  const half = (cut.transition?.durationMs ?? TRANSITION_MS) / 2;
  const from = timeline.clips.find((clip) => clip.id === cut.fromId);
  const to = timeline.clips.find((clip) => clip.id === cut.toId);
  if (from === undefined || to === undefined) return false;
  if (clipMs(from) < half || clipMs(to) < half) return false;
  // A transition already on the far end of the clip after the cut, and of the one before it.
  const after = timeline.transitions.find((each) => each.fromId === to.id);
  if (after !== undefined && after.durationMs + half >= clipMs(to)) return false;
  const before = timeline.transitions.find((each) => each.toId === from.id);
  return before === undefined || before.durationMs + half < clipMs(from);
}
